import {
  Toast
} from 'mint-ui'
import RuntimeException from './RuntimeException'

export const exception = function (message) {
  return function (target, key, descriptor) {
    const method = descriptor.value
    descriptor.value = async function (...args) {
      try {
        return await method.apply(this, args)
      } catch (e) {
        if (e.status != 0) {
          throw new RuntimeException(message, e)
        } else {
          return {};
        }
      }
    }
    return descriptor
  }
}

export const toast = function (message) {
  return function (target, key, descriptor) {
    const method = descriptor.value
    descriptor.value = async function (...args) {
      try {
        return await method.apply(this, args)
      } catch (e) {
        Toast(message || e.message)
        throw e
      }
    }
    return descriptor
  }
}



// WEBPACK FOOTER //
// ./src/util/decorators.js